Number.prototype.padLeft = function (base, chr) {
    var len = (String(base || 10).length - String(this).length) + 1;
    return len > 0 ? new Array(len).join(chr || '0') + this : this;
}

const Tools = {
    _gender: {
        1: "男", 2: "女"
    },
    init: function () {
        // console.warn("[init]");
    },
    getFormatDate: function (str) {
        var date = new Date(parseInt(str));
        var day = date.getDate().padLeft();
        var monthIndex = (date.getMonth() + 1).padLeft();
        var year = date.getFullYear();

        return year + "/" + monthIndex + "/" + day;
    },
    getFormatDateTime: function (str) {
        var date = new Date(parseInt(str));
        var day = date.getDate().padLeft();
        var monthIndex = (date.getMonth() + 1).padLeft();
        var year = date.getFullYear();
        let HH = date.getHours().padLeft();
        let mm = date.getMinutes().padLeft();
        let ss = date.getSeconds().padLeft();

        return `${year}/${monthIndex}/${day} ${HH}:${mm}:${ss}`;
    },
    dateToFormatStr: function (date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    },
    getGenderStr: function (str) {
        return this._gender[str];
    },
    validateEmail: function (email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    formatPrice: function (price) {
        let tmp = parseInt(price);
        if (isNaN(tmp)) return price;
        let result = null;
        while (tmp > 1000) {
            let right = (tmp % 1000) + "";
            while (right.length < 3) right = "0" + right;
            result = right + (result ? "," + result : "");
            tmp = Math.floor(tmp / 1000);
            console.log(result, tmp);
        }
        return (tmp % 1000) + (result ? "," + result : "");
    }
};
export default Tools;